const exportApiReport = {
  exportList: "/v3/manage/other/exportList", // 获取导出数据的列表
  downloadData: "/v3/manage/other/downloadExport", // 下载导出数据
  exportUrl: "/v3/manage/other/downloadExport" // 获取下载url
};
export default exportApiReport;



// WEBPACK FOOTER //
// ./src/service/basic/exportApiReport.js